export default __webpack_public_path__ + "static/media/inventario.ea1fa2e4.svg";